export const iconFontAwesomeFilesFolderOpen = (
	<i className="fa-solid fa-folder-open"></i>
);
